import { zodResolver } from '@hookform/resolvers/zod'
import { useForm } from 'react-hook-form'
import { z } from 'zod/v3'

const timeRegex = /^([01]?[0-9]|2[0-3]):[0-5][0-9]$/

const reapproCategoryGroupFormSchema = z.object({
  name: z
    .string()
    .min(1, { message: 'Le nom est requis' })
    .max(30, { message: 'Le nom ne peut pas dépasser 30 caractères' }),
  maxProduction: z
    .number({ invalid_type_error: 'Le max de production doit être un nombre' })
    .int({ message: 'Le max de production doit être un entier' })
    .positive({ message: 'Le max de production doit être positif' })
    .nullable(),
  computeHour: z.string().regex(timeRegex, { message: 'Heure de calcul invalide' }),
  sendHour: z.string().regex(timeRegex, { message: "Heure d'envoi invalide" }),
  daysBefore: z.coerce
    .number({ invalid_type_error: 'La valeur J-X doit être un nombre' })
    .min(1, { message: 'La valeur J-X doit être au moins 1' })
    .max(30, { message: 'La valeur J-X ne peut pas dépasser 30' }),
  reapproCategoryIds: z
    .array(z.number())
    .min(1, { message: 'Sélectionnez au moins une catégorie' }),
})

export type ReapproCategoryGroupForm = z.infer<typeof reapproCategoryGroupFormSchema>

const DEFAULT_REAPPRO_CATEGORY_GROUP_FORM_VALUES = {
  name: '',
  maxProduction: null,
  computeHour: '06:00',
  sendHour: '07:00',
  daysBefore: 1,
  reapproCategoryIds: [],
} satisfies ReapproCategoryGroupForm

export const useReapproCategoryGroupForm = (values?: ReapproCategoryGroupForm) =>
  useForm<ReapproCategoryGroupForm>({
    resolver: zodResolver(reapproCategoryGroupFormSchema),
    defaultValues: DEFAULT_REAPPRO_CATEGORY_GROUP_FORM_VALUES,
    values,
  })
